<template>
    <div class="categories">
        <section-title :title="'Категории'" :section_link="'categories'"></section-title>
        <div class="categories-cards">
            <div class="card" v-for="card in cards">
                <category-card
                        :title="card.title"
                        :items="card.items"
                ></category-card>
            </div>
        </div>
    </div>
</template>

<script>
    import CategoryCard from '../Cards/CategoryCard';
    import SectionTitle from '../Helpers/SectionTitle';
    export default {
        name: "CategoriesSection",
        components: { CategoryCard, SectionTitle },
        data() {
            return {
                cards: [
                    {
                        title: 'Електроника',
                        items: [
                            'Экшн камеры',
                            'Смарт часы',
                            'Power Bank',
                            'Гироскутеры',
                            'Беспроводные наушники',
                            'Портативные колонки',
                            'Проводные наушники',
                            'Другие товары',
                        ]
                    },
                    {
                        title: 'Экотовары',
                        items: [
                            'Посуда',
                            'Личная гигиена',
                            'Парфюмерия',
                            'Другие товары',
                        ],
                    },
                    {
                        title: 'Красота и здоровье',
                        items: [
                            'Косметика',
                            'Уход за руками и ногами',
                            'Массажеры',
                            'Уход за волосами',
                            'Корректирующее белье',
                            'Другие товары',
                        ],
                    },
                    {
                        title: 'Товары для дома',
                        items: [
                            'Товары для кухни',
                            'Дом и интерьер',
                            'Сад и огород',
                            'Кружки и термосы',
                            'Бытовая техника',
                            'Лампы и освещение',
                            'Товары для ремонта',
                            'Другие товары',
                        ],
                    },
                    {
                        title: 'Наручные часы',
                        items: [
                            'Механические часы',
                            'Умные часы',
                            'Мужские часы',
                            'Спортивне часы',
                            'Кварцевые часы',
                            'Популярные часы',
                            'Женские часы',
                            'Коробки и футляры',
                        ]
                    },
                    {
                        title: 'Украшения и бижутерия',
                        items: [
                            'Цепочки',
                            'Кольца',
                            'Серьги',
                            'Наборы украшений',
                            'Браслеты',
                            'Кулоны и подвески',
                            'Брелки',
                            'Другие товары',
                        ],
                    },
                    {
                        title: 'Автомобили и мотоциклы',
                        items: [
                            'Видеорегистраторы',
                            'Навигаторы',
                            'Инструменыт и уход',
                            'Антибликовые очки',
                            'Держатели для телефонов',
                            'Внутренние аксессуары',
                            'Внешние аксессуары',
                            'Другие товары',
                        ],
                    },
                    {
                        title: 'Хобби, спорт, путешествия',
                        items: [
                            'Спортивные товары',
                            'Фитнес-браслеты',
                            'Походные рюкзаки',
                            'Путешествия и пляж',
                            'Бинокли и монокляры',
                            'Рыбалка и охота',
                            'Фонари и лампы',
                            'Другие товары',
                        ],
                    },
                    {
                        title: 'Товары для взрослых',
                        items: [
                            'Мужчине',
                            'Женщине',
                            'Для двоих'
                        ],
                    }
                ]
            }
        }
    };
</script>

<style scoped lang="scss">
    .categories {
        &-cards {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
</style>
